<script>

	import { onMount, onDestroy, createEventDispatcher } from 'svelte';
	import { fly } from 'svelte/transition';

	import Results from "./Results.svelte";

	import Field from "../../../../ui/Field.svelte";
	import Button from "../../../../ui/Button.svelte";
	import Menu from "../../../../ui/Menu.svelte";
	import Dialog from "../../../../ui/Dialog.svelte";

	import { getServerData, postServerData } from '../../../../lib/prelude.js';
	import {	bigError, attendee, session, spotlight } from '../../../../lib/stores.js';
	import { autoblur } from '../../../../lib/autoblur.js';
	// import { logInteraction } from '../../../../lib/usage.js';

	const dispatch = createEventDispatcher();

	export let poll;
	export let mod;

	const resultsInterval = 10000; // 10 seconds here

	// console.log({$session});

	let mounted = false;
	let results = null;
	let resultsTimer;
	let showResults = true;

	let closePollDialog = null;
	let deletePollDialog = null;

	let response = ($session.pollResponses && $session.pollResponses[poll.ref]) ? $session.pollResponses[poll.ref] : null;

	onMount(async () => {

		// console.log({poll});
		// console.log('session', $session);

		showResults = true;
		results = {};
		checkResults(true);

		mounted = true;

	});

	async function checkResults(m) {
		if ((mounted || m) && showResults) {
			const pollData = await getServerData('onstage/polls', {
				poll: poll.ref
			});
			if (!$bigError) {
				results = pollData.results;
				if (!poll.closed) {
					clearTimeout(resultsTimer);
					resultsTimer = setTimeout(checkResults, resultsInterval);
				}
			}
		}
	}

	function actionClose() {
		closePollDialog = {
			text: "Are you sure you want to close this poll?",
			actions: [
				{
					label: "Confirm",
					dispatch: "confirm"
				},
				{
					label: "Cancel",
					ghost: true,
					dispatch: "escape"
				}
			]
		};
	}

	function actionDelete() {
		deletePollDialog = {
			text: "Are you sure you want to delete this poll?",
			actions: [
				{
					label: "Confirm",
					dispatch: "confirm"
				},
				{
					label: "Cancel",
					ghost: true,
					dispatch: "escape"
				}
			]
		};
	}

	function checkPoll() {
		// setDotsOptions();
		if (mounted) {
			if (poll.closed) {
				results = {};
				checkResults();
			}
		}
	}

	async function closePoll() {
		closePollDialog = null;
		postServerData('onstage/polls/close', {
			poll: poll.ref,
			index: poll.index
		});
	}

	function deletePoll() {
		deletePollDialog = null;
		postServerData('onstage/polls/delete', {
			poll: poll.ref,
			index: poll.index
		});
	}

	// function toggleHighlight() {
	// 	if (studioHighlight && (studioHighlight.t == 'poll') && (studioHighlight.r == poll.ref)) {
	// 		dispatch('highlight', null);
	// 	} else {
	// 		dispatch('highlight', { t: 'poll', r: poll.ref });
	// 	}
	// }

	onDestroy(() => {
		// console.log("clearTimeout", resultsTimer);
		clearTimeout(resultsTimer);
	});

	$: if (mounted && poll) {
		checkPoll();
	}

	// $: setDotsOptions(studioHighlight);

	// console.log('pollResponses', $session.pollResponses);

	function toggleSpotlight(m) {
		setTimeout(() => {
			if ($spotlight && ($spotlight.type == 'poll') && ($spotlight.index == m.index)) {
				$spotlight = null;
			} else {
				$spotlight = {
					type: 'poll',
					poll: {
						question: m.question,
						options: m.options
					},
					results: results,
					index: m.index,
					session: $session.ref
				};
			}
		}, 100);
	}

</script>

<style>
	.poll {
		position: relative;
		padding-top: 1rem;
		color: var(--textColor);
		font-size: 1rem;
	}

	/*.question {
		font-size: 0.9rem;
		margin-bottom: 0.5rem;
	}
	.question + p {
		margin-top: 0;
		font-size: 0.9rem;
	}

	.poll form :global(.field) {
		gap: 0 2rem;
	}

	.poll form :global(.labelgroup) {
		padding-top: 0;
		font-weight: 600;
	}*/

	.likes {
		display: flex;
		margin-top: 0.6rem;
		line-height: 1;
		margin-bottom: -0.1em;
		justify-content: space-between;
	}
	.likes span {
		vertical-align: middle;
		/*color: var(--blend-60);*/
		font-size: 0.8rem;
		font-weight: 600;
	}
	.likes svg {
		display: inline-block;
		/*width: 1em;
		height: 1em;*/
		width: 1.8em;
		height: 1.8em;
		vertical-align: middle;
		/*margin-left: 0.1em;*/
	}

	.likes button {
		display: flex;
		cursor: pointer;
		align-items: center;
		justify-content: flex-start;
		gap: 0.2em;
		padding: 0;
		border: 0;
		background: transparent;
		color: var(--textColor);
		font-size: 0.9rem;
	}

	.likes > span {
		display: flex;
		gap: 1.4rem;
	}

	.likes button:hover {
		color: var(--accentColor);
	}

	.likes button.lit {
		color: var(--accentColor);
	}

	.likes button.lit.spotlight {
		color: var(--errorColor);
	}

	.likes span.buttonLabel {
		font-weight: 400;
	}

</style>

{#if mounted}
	<div class="poll">
		<Results {poll} {results}/>
		<div class="likes">
			<span>
				{#if $attendee.type == 'login'}
					{#if !poll.closed}
						<button type="button" on:click|stopPropagation={actionClose} use:autoblur>
							<svg viewBox="0 0 80 80"><path d="M21.57 50.69v-30.52c0-1.23-1-2.23-2.23-2.23s-2.23 1-2.23 2.23v30.52h4.46zM13 55.09c-1.1 0-2-.9-2-2v-38.01c0-1.1.9-2 2-2h38c1.1 0 2 .9 2 2v8.46c1.36.04 2.7.17 4 .4v-10.85c0-2.21-1.79-4-4-4h-42c-2.21 0-4 1.79-4 4v41.99c0 2.21 1.79 4 4 4h16.13c-.45-1.29-.81-2.62-1.06-3.99h-13.07zM34.23 30.59v-1.83c0-1.23-1-2.23-2.23-2.23s-2.23 1-2.23 2.23v7.17c1.25-1.97 2.75-3.76 4.46-5.34zM52.31 29.52c-11.41 0-20.7 9.28-20.7 20.7 0 11.41 9.28 20.7 20.7 20.7s20.69-9.3 20.69-20.71-9.28-20.69-20.69-20.69zm0 4c3.88 0 7.45 1.34 10.29 3.58l-23.41 23.41c-2.23-2.84-3.58-6.41-3.58-10.29 0-9.21 7.49-16.7 16.7-16.7zm0 33.39c-3.88 0-7.45-1.34-10.29-3.58l23.41-23.41c2.23 2.84 3.57 6.41 3.57 10.29 0 9.21-7.49 16.7-16.69 16.7z"/></svg>
							<span class="buttonLabel">Close poll</span>
						</button>
					{/if}
				{/if}
				{#if mod}
					<button type="button" on:click|stopPropagation={actionDelete} use:autoblur>
						<svg viewBox="0 0 20 20"><title>Delete</title><path d="M12 14.5c-.28 0-.5-.22-.5-.5v-5.01c0-.28.22-.5.5-.5s.5.22.5.5v5.01c0 .28-.22.5-.5.5zM10 14.5c-.28 0-.5-.22-.5-.5v-5c0-.28.22-.5.5-.5s.5.22.5.5v5.01c0 .27-.22.49-.5.49zM8 14.5c-.28 0-.5-.22-.5-.5v-5c0-.28.22-.5.5-.5s.5.22.5.5v5.01c0 .27-.22.49-.5.49zM15.5 5.5c0-.55-.45-1-1-1h-2.49c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1h-2.51c-.55 0-1 .45-1 1v2h1v8c0 .55.45 1 1 1h7c.55 0 1-.45 1-1v-8h1v-2zm-2 9.5c0 .28-.22.5-.5.5h-6c-.28 0-.5-.22-.5-.5v-7.5h7v7.5zm1-8.5h-9v-.49c0-.28.22-.5.5-.5h8c.28 0 .5.22.5.5v.49z"/></svg>
						<span class="buttonLabel">Delete</span>
					</button>
				{/if}
			</span>
			<span>
				<button type="button" class="spotlight" on:click|stopPropagation={toggleSpotlight(poll)} use:autoblur class:lit={$spotlight && ($spotlight.type == 'poll') && ($spotlight.index == poll.index)}>
					{#if $spotlight && ($spotlight.type == 'poll') && ($spotlight.index == poll.index)}
						<span class="buttonLabel">Take off screen</span>
					{:else}
						<span class="buttonLabel">Show on screen</span>
					{/if}
					<svg viewBox="0 0 80 80">
						{#if $spotlight && ($spotlight.type == 'poll') && ($spotlight.index == poll.index)}
							<path d="m69.6 22.4c0-1.3-1.1-2.6-2.6-2.8-8.1-1.1-27-1.1-27-1.1s-18.9 0-27 1.1c-1.5.2-2.6 1.5-2.6 2.8-.4 8.6-.4 17.6-.4 17.6s0 9 .4 17.6c0 1.3 1.1 2.6 2.6 2.8 8.1 1.1 27 1.1 27 1.1s18.9 0 27-1.1c1.3-.2 2.4-1.3 2.6-2.8.4-8.6.4-17.6.4-17.6s0-9-.4-17.6zm-19.2 20.1h-20.9v-4.9h20.9z"/>
						{:else}
							<path d="m42.4 29.5v8.1h8v4.9h-8v8h-4.8v-8h-8v-4.9h8v-8.1z"/><path d="m40 22.6c.2 0 15.5 0 24.4.9.9 0 1.5.7 1.5 1.5.2 7.6.2 15 .2 15s0 7.4-.2 15c0 .9-.7 1.5-1.5 1.5-8.9.9-24.2.9-24.4.9s-15.5 0-24.4-.9c-.9 0-1.5-.7-1.5-1.5-.2-7.6-.2-14.8-.2-15 0 0 0-7.4.2-15 0-.9.7-1.5 1.5-1.5 8.9-.9 24.2-.9 24.4-.9m0-4s-18.9 0-27 1.1c-1.5.2-2.6 1.5-2.6 2.8-.4 8.5-.4 17.5-.4 17.5s0 9 .4 17.6c0 1.3 1.1 2.6 2.6 2.8 8.1 1.1 27 1.1 27 1.1s18.9 0 27-1.1c1.3-.2 2.4-1.3 2.6-2.8.4-8.6.4-17.6.4-17.6s0-9-.4-17.6c0-1.3-1.1-2.6-2.6-2.8-8.1-1-27-1-27-1z"/>
						{/if}
					</svg>
				</button>
			</span>
		</div>
	</div>
{/if}

{#if closePollDialog}
	<Dialog
		{...closePollDialog}
		on:escape={() => { closePollDialog = null}}
		on:confirm={closePoll}
	/>
{/if}

{#if deletePollDialog}
	<Dialog
		{...deletePollDialog}
		on:escape={() => { deletePollDialog = null}}
		on:confirm={deletePoll}
	/>
{/if}